// extracted by mini-css-extract-plugin
export default {"section":"CollabWorkspaceScreen_section__NvkYg","container":"CollabWorkspaceScreen_container__ReyNE"};